export default __webpack_public_path__ + "static/media/twitter.1a2f7251.svg";